import { render, staticRenderFns } from "./tb.vue?vue&type=template&id=168ee682&scoped=true&"
import script from "./tb.vue?vue&type=script&lang=js&"
export * from "./tb.vue?vue&type=script&lang=js&"
import style0 from "./tb.vue?vue&type=style&index=0&id=168ee682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ee682",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168ee682')) {
      api.createRecord('168ee682', component.options)
    } else {
      api.reload('168ee682', component.options)
    }
    module.hot.accept("./tb.vue?vue&type=template&id=168ee682&scoped=true&", function () {
      api.rerender('168ee682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/dialog/tokenInfo/tb.vue"
export default component.exports